<template>
  <div class="new-message" :class="{ disabled: disabled }" @click="handleClick">
    <PlusOutlined class="new-message__icon" />

    <p class="new-message__description">{{ text }}</p>
  </div>
</template>

<script setup lang="ts">
import { PlusOutlined } from "@ant-design/icons-vue";

import { NodeType } from "@/app/ivr/bot/utils/enums";

const props = defineProps<{ type: NodeType; text: string; disabled: boolean }>();

const emit = defineEmits<{
  (e: "click", type: NodeType): void;
}>();

const handleClick = () => emit("click", props.type);
</script>

<style scoped lang="sass">
.new-message
  height: 126px
  background: #FFF
  border-radius: 4px
  border: 1px dashed $blue-6
  cursor: pointer
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  gap: 10px

  &__icon
    display: block
    color: $blue-6
    font-size: 20px

  &__description
    font-size: 14px
    text-align: center
    color: $blue-6
    margin: 0
    padding: 0 60px

  &.disabled
    filter: grayscale(1)
    opacity: 0.6
    cursor: not-allowed
</style>
